// import { Provider } from '@prisma/client'
import { Avatar } from 'antd'
import { Toolbox } from '~/plugins/toolbox/shared'
import { useProvider } from '../../hooks/useProvider'

type Props = {
  provider: any
}

export const DataConnectorIcon: React.FC<Props> = ({ provider }) => {
  const color = Toolbox.Utility.stringToGradient(provider.name)

  const { providerClient } = useProvider({ provider })

  if (providerClient) {
    return providerClient.description.icon
  }

  return (
    <Avatar
      shape="square"
      size="small"
      style={{ background: color, borderColor: 'white' }}
    />
  )
}
